import React from 'react';
import { Tag } from 'antd';
import { ETripTaskStatus, TRIP_TASK_STATUS_MAP } from 'types/trip-task-status';
import type { ITTripTaskItemStatusProps } from './types';

export const TripTaskItemStatus: React.FC<ITTripTaskItemStatusProps> = ({ status }) => {
  let color = 'default';

  if (status === ETripTaskStatus.unconfirmed) {
    color = 'warning';
  } else if (status === ETripTaskStatus.executing) {
    color = 'processing';
  } else if (status === ETripTaskStatus.done) {
    color = 'success';
  }

  return <Tag color={color}>{TRIP_TASK_STATUS_MAP[status]}</Tag>;
};
